import { Link, Outlet, useRouterState } from '@tanstack/react-router';
import { cn } from '@shigo-ui/ui/cn';

import { dashboardT } from '../../../../../lib/messages';
import { ShigoPermission } from '../../../../auth/permissions';
import { useShigoPermissions } from '../../../../auth/useShigoPermissions';
import { AdsTxtTab } from '../../model';

const tabPermissions = {
  [AdsTxtTab.Records]: ShigoPermission.SupplyAdsTxtRecordsRead,
  [AdsTxtTab.Apps]: ShigoPermission.SupplyAdsTxtAppsRead,
  [AdsTxtTab.Domains]: ShigoPermission.SupplyAdsTxtDomainsRead,
} as const;

export function AdsTxtLayout() {
  const pathname = useRouterState({ select: (state) => state.location.pathname });
  const { can } = useShigoPermissions();
  const tabs = Object.values(AdsTxtTab).filter((tab) => can(tabPermissions[tab]));
  return (
    <div className="flex min-h-0 min-w-0 flex-1 flex-col">
      <nav
        aria-label={dashboardT('adsTxt.tabs.label')}
        className="border-border bg-card page-gutter shrink-0 border-b"
      >
        <div className="flex min-w-max gap-1 overflow-x-auto">
          {tabs.map((tab) => {
            const to = `/supply/ads-txt/${tab}` as const;
            return (
              <Link
                key={tab}
                to={to}
                search={{}}
                aria-current={pathname === to ? 'page' : undefined}
                className={cn(
                  'text-muted-foreground border-b-2 border-transparent px-3 py-3 text-sm font-medium whitespace-nowrap transition-colors',
                  pathname === to && 'shigo-supply-tab--active',
                )}
              >
                {dashboardT(`adsTxt.tabs.${tab}`)}
              </Link>
            );
          })}
        </div>
      </nav>
      <Outlet />
    </div>
  );
}
